import { Grid } from '@material-ui/core';
import styled, { css } from 'styled-components';
import { lightColorPalette } from '@linearb/linui-common';

export const GridWrapper = styled(Grid)`
  & > .MuiGrid-grid-xs-1 {
    flex-grow: 0;
    max-width: 12.5%;
    flex-basis: 15.5%;
  }
`;

export const FreeTierGridItem = styled(Grid)`
  padding-bottom: 1rem;
  padding-right: 0.7rem;
`;

export const FreeTierLastInLineGridItem = styled(FreeTierGridItem)`
  padding-right: 0;
`;

export const WhiteSectionCss = css`
  background-color: ${lightColorPalette.lbWhite};
  box-sizing: border-box;
  display: flex;
  border-radius: 0.45rem;
  height: 22rem;
`;
